export default "__VITE_ASSET__Druv$E_6__"